import { props } from "bluebird";
import React from "react";
import Avatar from '@material-ui/core/Avatar';
import ImageIcon from '@material-ui/icons/Image';
import CloseIcon from '@material-ui/icons/Close';
import Button from "@material-ui/core/Button";

import Styles from "./ModalBtns.module.css";

const ModalBtns = (props) => {
  return (
      <div className={Styles["ModalBtns"]}>
        <CloseIcon className={Styles["CloseModal"]} style={{"cursor": "pointer"}} onClick={props.onCancel}/>
        <div className={Styles["ModalContent"]}>
        <div className={Styles["modal-title"]}>{props.title}</div>
        <div className={Styles["modal-text"]}>{props.text}</div>
          <Button variant="contained" color="primary" className={Styles["modal-button"]} onClick={props.onOk}>
            Sim
          </Button>
          <Button variant="contained" color="primary" className={Styles["modal-button"]} onClick={props.onCancel}>
            Não
          </Button>
        </div>
      </div>
  );
};
export default ModalBtns;